import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";


export interface DialogData {
  projects: any
}
@Component({
  selector: 'app-assign-staff',
  templateUrl: './assign-staff.component.html',
  styleUrls: ['./assign-staff.component.css']
})
export class AssignStaffComponent implements OnInit {
  public loading = false;
  constructor(
    public dialogRef: MatDialogRef<AssignStaffComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService
  ) { }

  ngOnInit() {
    this.data.projects.designer_id = this.data.projects.designer_id === null ? '' : this.data.projects.designer_id;
    this.data.projects.printer_id = this.data.projects.printer_id === null ? '' : this.data.projects.printer_id;
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  assignStaff = function () {
    if ((this.data.projects.designer_id != '' && this.data.projects.designer_id != null) && (this.data.projects.printer_id != '' && this.data.projects.printer_id != null)) {
      this.loading = true;
      let statusOptions = {
        id: localStorage.getItem("userID"),
        designer_id: this.data.projects.designer_id,
        printer_id: this.data.projects.printer_id,
        invoice_id: this.data.projects.order_id
      };
      this.CommonService.apiService(
        "POST",
        "job/assign",
        statusOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this.dialogRef.close(response);
          }
        },
        err => {
          this.loading = false;
          console.log(err);
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-danger",
            timeout: 5000
          });
        }
      );
    }
    else {
      this._flashMessagesService.show("printer and designer name is required", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/assign-staff/assign-staff.component.ts